import { generateOtp } from "src/modules/auth/ajax/cloud";
import { pairingTypes, pairingResults } from "src/modules/pairing/constants";
import { relogAsDifferentUser } from "src/modules/auth/duck/epics";
import { getXmppLogin } from "src/modules/auth/duck/selectors";
import { openWizard } from "src/modules/pairing/duck/actions";
import { updatePairedDevice } from "src/modules/device/duck/actions";

import { confirmDevicePairing } from "../../ajax/cloud";
import { pairingFailed } from "../../duck/actions";
import { getRequest } from "../../duck/selectors";

const log = window.require("electron-log");

export default function handlePairingConfirmation({
  sendResponseMessage,
  messenger,
  app
}) {
  return async (dispatch, getState) => {
    const state = getState();
    const request = getRequest(state);
    const xmppLogin = getXmppLogin(state);
    try {
      await confirmDevicePairing(
        request.requestId,
        xmppLogin,
        request.pairingType
      );

      switch (request.pairingType) {
        case pairingTypes.THEIR_FAMILY: {
          const otpData = await generateOtp();
          sendResponseMessage({
            otpData,
            result: pairingResults.ACCEPTED
          });
          dispatch(openWizard({ initialStep: "responder-success" }));
          return;
        }

        case pairingTypes.OUR_FAMILY:
        case pairingTypes.OUR_FAMILY_CREATE:
        case pairingTypes.INITIAL:
          await dispatch(
            relogAsDifferentUser({
              authId: request.authId,
              otp: request.otp,
              messenger,
              app
            })
          );
          sendResponseMessage({
            result: pairingResults.ACCEPTED
          });
          dispatch(openWizard({ initialStep: "responder-success" }));
          return;

        case pairingTypes.DEVICES:
          sendResponseMessage({
            result: pairingResults.ACCEPTED
          });
          dispatch(
            updatePairedDevice({
              jid: request.from,
              group: "others",
              name: request.deviceName,
              familyName: request.familyName
            })
          );
          dispatch(openWizard({ initialStep: "responder-success" }));
          return;
        default:
          return;
      }
    } catch (err) {
      log.error(err);
      dispatch(pairingFailed());
      sendResponseMessage({
        result: pairingResults.FAILED
      });
      // TODO: refactor this rethrow which is used in ConfirmationDialog
      throw err;
    }
  };
}
